import { createSelector } from 'reselect';

import { StoreState } from '../../reducers';
import Utils from '../../utils';

const getApplicationUrl = (state: StoreState): string => state.galleryInfos.config.applicationUrl;

const getNewAvatar = createSelector(
	(state: StoreState): File | null | undefined => state.profile.userAvatar.file,
	(file: File): string => file ? URL.createObjectURL(file) : '',
);

const getCurrentAvatar = createSelector(
	(state: StoreState): string | null => state.profile.photoPath,
	getApplicationUrl,
	(photoPath: string, applicationUrl: string): string => photoPath ? Utils.getUrlForSecuredResource(`${applicationUrl}/${photoPath}`) : '',
);

export const getAvatarUrl = createSelector(
	getNewAvatar,
	getCurrentAvatar,
	(newAvatar: string, currentAvatar: string): string => newAvatar || currentAvatar,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/selectors.tsx